export const QUICK_ALERT_DUPLICATE_BUTTON_LABEL_MESSAGE =
  "Quick Alert with this name already exists.";

export type QuickAlertGroupRef = {
  id: string | number;
};

export type QuickAlertListItem = {
  _id: string | number;
  alertButtonName?: string | null;
  groups?: QuickAlertGroupRef[];
};

type QuickAlertDuplicateOptions = {
  name: string;
  groups?: QuickAlertGroupRef[];
  existingAlerts: QuickAlertListItem[] | null | undefined;
  excludeAlertId?: string | number | null;
};

const normalizeQuickAlertName = (value: string | null | undefined) =>
  String(value ?? "").trim().toLowerCase();

export function findQuickAlertButtonLabelConflict({
  name,
  existingAlerts,
  excludeAlertId,
}: QuickAlertDuplicateOptions): QuickAlertListItem | null {
  const normalizedName = normalizeQuickAlertName(name);

  if (!normalizedName || !Array.isArray(existingAlerts)) {
    return null;
  }

  const excludedId =
    excludeAlertId !== null && excludeAlertId !== undefined
      ? String(excludeAlertId)
      : null;

  return (
    existingAlerts.find((alert) => {
      if (!alert) return false;

      if (excludedId && String(alert._id) === excludedId) {
        return false;
      }

      const existingName = normalizeQuickAlertName(alert.alertButtonName);

      return existingName === normalizedName;
    }) ?? null
  );
}

export function getQuickAlertButtonLabelDuplicateMessage(
  options: QuickAlertDuplicateOptions
): string | null {
  const conflict = findQuickAlertButtonLabelConflict(options);

  return conflict ? QUICK_ALERT_DUPLICATE_BUTTON_LABEL_MESSAGE : null;
}